import { useCallback, useEffect, useState } from 'react';
import { useLocation, useBlocker } from 'react-router-dom';
import { useDispatch } from 'react-redux';
// actions
import { UnBlockRouteTransitions } from '../actions/router';

export function useCallbackPrompt(when) {
  const location = useLocation();
  const dispatch = useDispatch();

  const [showPrompt, setShowPrompt] = useState(false);
  const [isOnlyTimer, setIsOnlyTimer] = useState(false);
  const [patientId, setPatientId] = useState(null);
  const [patientChanged, setPatientChanged] = useState(true);

  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) => {
      if (!when) return false;

      let shouldPrompt = nextLocation.pathname !== currentLocation.pathname;

      // Timer condition logic
      if (shouldPrompt && isOnlyTimer && patientId) {
        shouldPrompt = !nextLocation.pathname.includes(patientId);
      }

      return shouldPrompt;
    }
  );

  // Sync the blocker state to modal visibility
  useEffect(() => {
    if (blocker.state === 'blocked') {
      if (patientId && blocker.location) {
        setPatientChanged(!blocker.location.pathname.includes(patientId));
      }
      setShowPrompt(true);
    } else {
      setShowPrompt(false);
    }
  }, [blocker.state, blocker.location, patientId]);

  // Handle "OK/Confirm" button click
  const confirmNavigation = useCallback(() => {
    setShowPrompt(false);
    dispatch(UnBlockRouteTransitions());
    if (blocker.state === 'blocked') {
      blocker.proceed();
    }
  }, [blocker, dispatch]);

  // Handle "Cancel" button click
  const cancelNavigation = useCallback(() => {
    setShowPrompt(false);
    if (blocker.state === 'blocked') {
      blocker.reset();
    }
  }, [blocker]);

  return [
    showPrompt, setIsOnlyTimer, setPatientId, confirmNavigation,
    cancelNavigation, patientChanged,
  ];
}